import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import api from '../../services/api';
import {Container, Atencao, DropContainer, UploadMessage} from './styles';
import Alerta from '../../assets/icones/icon_alert-triangle.svg';
import {FiChevronDown} from 'react-icons/fi';
import {IoArrowBack, IoSearch} from 'react-icons/io5';
import { MdCheckCircle, MdError } from 'react-icons/md'
import {Switch} from 'antd';
import { Spinner } from 'react-activity';
import CurrencyInput from 'react-currency-input';
import Empresa from '../../assets/emojis/empresa/empresa@3x.png'
import ImageIcon from '../../assets/icon_image.svg';
import Modal from 'react-modal';
import ModalSelect from './modalSelect';
import Dropzone from 'react-dropzone';
import {CircularProgressbar} from 'react-circular-progressbar';
import { uniqueId } from 'lodash';
import filesize from 'filesize';
import '../../css/devices.min.css';
import CapaVazia from '../../assets/celular/capa_vazia.png';
import Bar from '../../assets/celular/bar.png';
import LogoVazia from '../../assets/celular/logo_vazia.png';
import Tabs from '../../assets/celular/tabs.png';
import { toast, Slide, ToastContainer } from 'react-toastify';
import '../../css/ReactToastify.css';
import { IoMdCloseCircle, IoMdCheckmarkCircle } from 'react-icons/io'
const entrada = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-140%, -50%)',
        width: '100%',
        maxWidth: '322px',
        height: '100%',
        maxHeight: '756px'
      }
  };

const mobile = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -42%)',
        width: '100%',
        maxWidth: '360px',
        height: '85%',
      }
  };

export default class Restaurante extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cepLoading: false,
            carregou: false,
            alerta: false,
            token: '',
            redirect: false,
            cozinhas: [],
            nome: '',
            nomeClass: 'div-input',
            descricao: '',
            prevDescricao: '',
            descClass: 'div-input-box',
            cep: '',
            prevCep: '',
            cepClass: 'div-input',
            endereco: '',
            prevEndereco: '',
            enderecoClass: 'div-input',
            numero: '',
            prevNumero: '',
            numeroClass: 'div-input',
            cidade: '',
            cidadeClass: 'div-input',
            complemento: '',
            prevComplemento: '',
            complementoClass: 'div-input',
            bairro: '',
            prevBairro: '',
            bairroClass: 'div-input',
            valor: '',
            prevValor: '',
            valorClass: 'div-input',
            tempo: '',
            prevTempo: '',
            tempoClass: 'div-input',
            tempoRetiradaClass: 'div-input',
            retirada: false,
            prevRetirada: false,
            tempo_retirada: '',
            windowWidth: window.innerWidth,
            isOpen: false,
            isRetiradaOpen: false,
            uploadedCapa: [],
            uploadedLogo: [],
            cepError: false,
            rest: {},
            superUser: false,
            permission: null,
            imagem_capa: '',
            logotipo: '',
        }
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    componentWillUnmount() {
        window.addEventListener("resize", this.handleResize)
    }

    async componentDidMount() {
        let componentDidMount_super = CurrencyInput.prototype.componentDidMount;
        CurrencyInput.prototype.componentDidMount = function() {
            if(!this.props.autoFocus) {
                let setSelectionRange_super = this.theInput.setSelectionRange;
                this.theInput.setSelectionRange = () => {};
                componentDidMount_super.call(this, ...arguments);
                this.theInput.setSelectionRange = setSelectionRange_super;
            }
            else {
                componentDidMount_super.call(this, ...arguments);
            }
        };
        let componentDidUpdate_super = CurrencyInput.prototype.componentDidUpdate;
        CurrencyInput.prototype.componentDidUpdate = function() {
            if(!this.props.autoFocus) {
                let setSelectionRange_super = this.theInput.setSelectionRange;
                this.theInput.setSelectionRange = () => {};
                componentDidUpdate_super.call(this, ...arguments);
                this.theInput.setSelectionRange = setSelectionRange_super;
            }
            else {
                componentDidMount_super.call(this, ...arguments);
            }
        };
        toast.configure();
        Modal.setAppElement('body');
        window.addEventListener("resize", this.handleResize)

        const token = await localStorage.getItem('@jwt');
        const rest = await JSON.parse(localStorage.getItem('@rest'));
        const isSuser = await localStorage.getItem('@internal');

        this.setState({ token: token, nome: rest.nome, cidade: rest.cidade.nome, rest });

        if (isSuser) {
            const permissions = await JSON.parse(localStorage.getItem('@suser'));
            this.setState({superUser: true, permission: permissions.configuracoes});
        }
        if (this.state.superUser) {
            if (this.state.permission !== 0) {
                await this.getCozinhas();
                await this.getRestInfo().then(() => {
                    this.setState({carregou: true});
                });
            }
        } else {
            await this.getCozinhas();
            await this.getRestInfo().then(() => {
                this.setState({carregou: true});
            })
        }
    }

    async getCozinhas() {
        try {
            await api.get('api/restauranteconfigs/cozinha', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.setState({
                    cozinhas: res.data.cozinhaRestaurante
                })
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (e) {
            console.log(e);
        }
    }

    async getRestInfo() {
        try {
            await api.get('api/restaurantepagina/informacoesRestaurante', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.setState({
                    descricao: res.data.infos.descricao,
                    prevDescricao: res.data.infos.descricao,
                    endereco: res.data.infos.rua,
                    prevEndereco: res.data.infos.rua,
                    numero: res.data.infos.numero,
                    complemento: res.data.infos.complemento,
                    prevComplemento: res.data.infos.complemento,
                    bairro: res.data.infos.bairro,
                    prevBairro: res.data.infos.bairro,
                    prevNumero: res.data.infos.numero,
                    cep: res.data.infos.cep,
                    prevCep: (res.data.infos.cep).substr(0, 9),
                    tempo: (res.data.infos.tempo_entrega).substr(0,5),
                    prevTempo: (res.data.infos.tempo_entrega).substr(0,5),
                    valor: String(res.data.infos.pedido_minimo),
                    prevValor: String(res.data.infos.pedido_minimo),
                    retirada: res.data.infos.retirar_local,
                    prevRetirada: res.data.infos.retirar_local,
                    tempo_retirada: res.data.infos.tempo_retirada ? (res.data.infos.tempo_retirada).substr(0,5) : null,
                    imagem_capa: res.data.infos.imagem_capa,
                    logotipo: res.data.infos.logotipo,
                })
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    success = () => {
        toast.dismiss();
        const ToastSuccess = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCheckmarkCircle color="#51db74" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#5b8e3e",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>As alterações foram salvas com sucesso.</span>
                </div>
            </div>
        );
        toast.success(<ToastSuccess />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide,
        });
    }
    error = () => {
        toast.dismiss();
        const ToastError = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCloseCircle color="#d2252e" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#983236",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>Ocorreu um erro. Tente novamente mais tarde.</span>
                </div>
            </div>
        );
        toast.error(<ToastError />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide
        });
    }

    async putDescricao() {
        if (this.state.descricao !== this.state.prevDescricao) {
            try {
                await api.put('api/restaurantepagina/editarRestInfo', {
                    descricao: this.state.descricao
                }, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    this.setState({
                        prevDescricao: this.state.descricao
                    })
                    this.success();
                }).catch(async e => {
                    this.error();
                    if (e.response.status === 401) {
                        try {
                            await localStorage.removeItem('@username');
                            await localStorage.removeItem('@jwt');
                            await localStorage.removeItem('@user');
                            await localStorage.removeItem('@rest');
                            await localStorage.removeItem('@uf');
                            await localStorage.removeItem('@internal');
                            await localStorage.removeItem('@suser');
                            this.setState({
                                redirect: true
                            })
                        } catch (e) {
                            console.log(e.data);
                        }
                    }
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    async putMinimo() {
        if (this.state.valor !== this.state.prevValor) {
            try {
                await api.put('api/restauranteconfigs/mudarminimo', {
                    pedido_minimo: this.state.valor
                }, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    this.setState({
                        prevValor: this.state.valor
                    })
                    this.success();
                }).catch(async e => {
                    this.error();
                    if (e.response.status === 401) {
                        try {
                            await localStorage.removeItem('@username');
                            await localStorage.removeItem('@jwt');
                            await localStorage.removeItem('@user');
                            await localStorage.removeItem('@rest');
                            await localStorage.removeItem('@uf');
                            await localStorage.removeItem('@internal');
                            await localStorage.removeItem('@suser');
                            this.setState({
                                redirect: true
                            })
                        } catch (e) {
                            console.log(e.data);
                        }
                    }
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    async putEntrega() {
        if (this.state.tempo !== '' && this.state.tempo !== this.state.prevTempo) {
            try {
                await api.put('api/restauranteconfigs/alterartempo', {
                    tempo_entrega: `${this.state.tempo}:00`
                }, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    this.setState({
                        prevTempo: this.state.tempo
                    })
                    this.success();
                }).catch(async e => {
                    this.error();
                    if (e.response.status === 401) {
                        try {
                            await localStorage.removeItem('@username');
                            await localStorage.removeItem('@jwt');
                            await localStorage.removeItem('@user');
                            await localStorage.removeItem('@rest');
                            await localStorage.removeItem('@uf');
                            await localStorage.removeItem('@internal');
                            await localStorage.removeItem('@suser');
                            this.setState({
                                redirect: true
                            })
                        } catch (e) {
                            console.log(e.data);
                        }
                    }
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    async putRetirada() {
        if (this.state.retirada === false) {
            this.setState({prevRetirada: false})
            await api.put('api/restauranteconfigs/alteraretirada', {
                retirada: this.state.retirada
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }
            )
            return
        }

        if (this.state.retirada === true) {
            try {
                await api.put('api/restauranteconfigs/alteraretirada', {
                    retirada: this.state.retirada,
                    tempo_retirada: this.state.tempo_retirada

                }, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    this.setState({
                        prevRetirada: this.state.retirada
                    })
                    this.success();
                }).catch(async e => {
                    this.error();
                    if (e.response.status === 401) {
                        try {
                            await localStorage.removeItem('@username');
                            await localStorage.removeItem('@jwt');
                            await localStorage.removeItem('@user');
                            await localStorage.removeItem('@rest');
                            await localStorage.removeItem('@uf');
                            await localStorage.removeItem('@internal');
                            await localStorage.removeItem('@suser');
                            this.setState({
                                redirect: true
                            })
                        } catch (e) {
                            console.log(e.data);
                        }
                    }
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    async putEndereco() {
        if ((this.state.endereco && this.state.numero && this.state.cep) !== '' && this.state.cep.length === 9) {
            if ((this.state.cep !== this.state.prevCep || this.state.endereco !== this.state.prevEndereco || this.state.numero !== this.state.prevNumero || this.state.complemento !== this.state.prevComplemento) && !this.state.cepError) {
                try {
                    await api.put('api/restauranteconfigs/endereco', {
                        rua: this.state.endereco,
                        numero: this.state.numero,
                        cep: this.state.cep,
                        complemento: this.state.complemento,
                        bairro: this.state.bairro
                    }, {
                        headers: {
                            Authorization: `Bearer ${this.state.token}`
                        }
                    }).then(res => {
                        this.setState({
                            prevEndereco: this.state.endereco,
                            prevCep: this.state.cep,
                            prevNumero: this.state.numero,
                            prevComplemento: this.state.complemento,
                            prevBairro: this.state.bairro
                        })
                        this.success();
                    }).catch(async e => {
                        this.error();
                        if (e.response.status === 401) {
                            try {
                                await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                                this.setState({
                                    redirect: true
                                })
                            } catch (e) {
                                console.log(e.data);
                            }
                        }
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        } else {
            this.error();
        }
    }

    pesquisarCep(value) {
        if (value.length === 9) {
            this.setState({
                cepLoading: true
            });
            const splits = value.split('-')
          fetch(`https://brasilapi.com.br/api/cep/v1/${splits[0]}${splits[1]}`)
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.type === "service_error") {
                    this.setState({
                        cepClass: 'div-input-error',
                        cepError: true,
                        cepLoading: false,
                        endereco: '',
                        numero: ''
                    });
                } else {
                    this.setState({
                      cepLoading: false,
                      cepError: false,
                      cepClass: 'div-input',
                      endereco: responseJson.street,
                      bairro: responseJson.neighborhood
                    });
                }
            })
            .catch((error) => {
                this.setState({ cepLoading: false })
              console.error(error);
            });
        }
      }

    handleInputs(event) {
        switch (event.target.name) {
            case 'nome':
                this.setState({
                    nome: event.target.value
                })
                break;
            case 'descricao':
                this.setState({
                    descricao: event.target.value
                })
                break;
            case 'cep':
                function mCEP(cep){
                    cep=cep.replace(/\D/g,"")
                    cep=cep.replace(/^(\d{5})(\d)/,"$1-$2")
                    return cep
                }
                const cep = mCEP(event.target.value);
                this.setState({
                    cep
                });
                this.pesquisarCep(cep);
                break;
            case 'endereco':
                    this.setState({
                        endereco: event.target.value
                    })
                    break;
            case 'numero':
                this.setState({
                    numero: event.target.value
                })
                break;
            case 'tempoRetirada':
                this.setState({
                    tempo_retirada: event.target.value
                })
                break;
            case 'cidade':
                this.setState({
                    cidade: event.target.value
                })
                break;
            case 'complemento':
                this.setState({
                    complemento: event.target.value
                })
                break;
            case 'bairro':
                this.setState({
                    bairro: event.target.value
                })
                break;
            case 'valor':
                var valor = event.target.value;
                var formatValue = valor.split(' ');
                var formated = formatValue[1]?.replace(/,/g, '.');
                this.setState({
                    valor: Number(formated).toFixed(2)
                });
                break;
        
            default:
                break;
        }
    }

    async updateInfos() {
        if (!!this.state.uploadedCapa.length) {
            this.processUploadCapa(this.state.uploadedCapa[0]);
        }
        if (!!this.state.uploadedLogo.length) {
            this.processUploadLogo(this.state.uploadedLogo[0]);
        }
        this.putDescricao();
    }

    controllerModal(estado){
        if (this.state.tempoClass === 'div-input') {
            this.setState({
                tempoClass: 'div-input-focado'
            })
        } else {
            this.setState({
                tempoClass: 'div-input'
            })
        }
        this.setState({
            isOpen: !estado,
        });
      }

      setHorario(horario) {
        this.setState({
            tempo: horario,
        });
        this.controllerModal(this.state.isOpen); 
    }

    controllerTempoRetiradaModal(estado){
        if (this.state.tempoRetiradaClass === 'div-input') {
            this.setState({
                tempoRetiradaClass: 'div-input-focado'
            })
        } else {
            this.setState({
                tempoRetiradaClass: 'div-input'
            })
        }
        this.setState({
            isRetiradaOpen: !estado,
        });
      }

    setTempoRetirada(horario) {
        this.setState({
            tempo_retirada: horario
        });
        this.controllerTempoRetiradaModal(this.state.isRetiradaOpen); 
    }

    renderDragMessage = (isDragActive, isDragReject, state, type) => {
        if (isDragActive) {
            if (isDragReject) {
                return <UploadMessage type="error">
                    <span className="bold">Arquivo não suportado</span>
                </UploadMessage>
            } else {
                return <UploadMessage >
                    <span className="bold">Solte a imagem aqui</span>
                </UploadMessage>
            }
        }

        if (!!state.length) {
            return <UploadMessage>
                <span className="nome">{state[0].name}</span>
                <span>Para alterar a imagem arraste e solte ou clique 
                <p>para importar do seu dispositivo.</p></span>
            </UploadMessage>
        }

        if (!state.length) {
            return <UploadMessage>
                <span><span className="bold">Arraste e solte</span> {type ? 'o seu logo' : 'a capa do seu restaurante'} 
                <p>ou <span className="bold">clique para importar</span> do seu dispositivo.</p></span>
            </UploadMessage>
        }
    }

    handleUploadCapa = file => {
        const uploadedCapa = file.map(file => ({
            file,
            id: uniqueId(),
            name: file.name,
            readableSize: filesize(file.size),
            preview: URL.createObjectURL(file),
            progress: 0,
            uploaded: false,
            error: false,
            url: null,
        }));

        this.setState({
            uploadedCapa
        });
    }

    handleUploadLogo = file => {
        const uploadedLogo = file.map(file => ({
            file,
            id: uniqueId(),
            name: file.name,
            readableSize: filesize(file.size),
            preview: URL.createObjectURL(file),
            progress: 0,
            uploaded: false,
            error: false,
            url: null,
        }));

        this.setState({
            uploadedLogo
        });
    }

    updateCapa = (id, data) => {
        this.setState({ uploadedCapa: this.state.uploadedCapa.map(uploadedFile => {
            return id === uploadedFile.id 
                ? { ...uploadedFile, ...data }
                : uploadedFile;
            })
        });
        this.setState({imagemCarregada: true})
    };

    updateLogo = (id, data) => {
        this.setState({ uploadedLogo: this.state.uploadedLogo.map(uploadedFile => {
            return id === uploadedFile.id 
                ? { ...uploadedFile, ...data }
                : uploadedFile;
            })
        });
        this.setState({logotipoCarregado: true})
    };

    processUploadCapa = (uploadCapa) => {
        if (!uploadCapa.uploaded) {
            const data = new FormData();
            let {rest} = this.state;

            data.append('file', uploadCapa.file, uploadCapa.name);

            api.post('api/restauranteconfigs/uploadcapa', data, {
                onUploadProgress: e => {
                    const progress = parseInt(Math.round(e.loaded * 100 / e.total));

                    this.updateCapa(uploadCapa.id, {
                        progress,
                    })
                },
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                const url = res.data.key;
                rest.imagem_capa = url;
                await localStorage.setItem('@rest', JSON.stringify(rest));
                this.updateCapa(uploadCapa.id, {
                    uploaded: true,
                });
                this.success();
                window.location.reload(true);
            }).catch(e => {
                // if (e.response.status === 500) {
                //     alert('Seu arquivo ultrapassou o limite de tamanho. Por favor, escolha outro arquivo e faça o upload.');
                // }
                this.updateCapa(uploadCapa.id, {
                    error: true,
                });
                this.error();
            })
        }
    }

    processUploadLogo = (uploadLogo) => {
        if (!uploadLogo.uploaded) {
            const data = new FormData();
            let {rest} = this.state;
            data.append('file', uploadLogo.file, uploadLogo.name);

            api.post('api/restauranteconfigs/uploadlogo', data, {
                onUploadProgress: e => {
                    const progress = parseInt(Math.round(e.loaded * 100 / e.total));

                    this.updateLogo(uploadLogo.id, {
                        progress,
                    })
                },
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                const url = res.data.key;
                rest.logotipo = url;
                await localStorage.setItem('@rest', JSON.stringify(rest));
                this.updateLogo(uploadLogo.id, {
                    uploaded: true,
                });
                this.success();
                window.location.reload(true);
            }).catch(e => {
                // if (e.response.status === 500) {
                //     alert('Seu arquivo ultrapassou o limite de tamanho. Por favor, escolha outro arquivo e faça o upload.');
                // }
                this.updateLogo(uploadLogo.id, {
                    error: true,
                });
                this.error();
            })
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/login"/>
        }
        const content = (
            <div className="celular">
                <img
                    src={Bar} alt=""/>
                <div className="top-tab">
                    <div className="div-nome">
                        <IoArrowBack color={'#fff'} size={22} className="icon"/>
                            <span className="nome-celular">
                                {this.state.nome}
                            </span>
                    </div>
                <IoSearch color={'#fff'} size={22} className="icon"/>
                </div>
                <div className="capa">
                    
                    <img
                        src={this.state.uploadedCapa.length ? 
                            this.state.uploadedCapa[0].preview : 
                        this.state.imagem_capa ?  `https://appedidos-share-private.s3.amazonaws.com/${this.state.imagem_capa}`  : CapaVazia} alt=""/>
                </div>
                <div className="logo">
                    <img
                        src={this.state.uploadedLogo.length ? this.state.uploadedLogo[0].preview : 
                        this.state.logotipo ?`https://appedidos-share-private.s3.amazonaws.com/${this.state.logotipo}` : LogoVazia} alt=""/>
                </div>

                <span className="descricao">
                {this.state.descricao === '' ? 'Digite a sua descrição' : this.state.descricao}
                </span>

                <div className="tabs">
                    <img
                        src={Tabs} alt=""/>
                </div>
                
            </div>
        )
        return(
            this.state.superUser && this.state.permission === 0 ? (
                <Container>
                    <h1 style={{
                        fontFamily: 'Montserrat',
                        fontSize: 18,
                        fontWeight: 600
                    }}>Você não possui permissão para visualizar esta página.</h1>
                </Container>
            ) : (
            <Container>
                <ToastContainer limit={1} />
                <Modal
                    isOpen={this.state.isOpen}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModal(this.state.isOpen)}
                    closeModal={() => this.controllerModal(this.state.isOpen)}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930  ? entrada : mobile}
                    contentLabel="Modal"
                    >
                        <ModalSelect
                            selecionar={(horario) => this.setHorario(horario)}
                            closeModal={() => this.controllerModal(this.state.isOpen)}/>

                </Modal>

                <Modal
                    isOpen={this.state.isRetiradaOpen}
                    // onAfterOpen={this.controllerTempoRetiradaModal(this.state.isRetiradaOpen)}
                    onRequestClose={() => this.controllerTempoRetiradaModal(this.state.isRetiradaOpen)}
                    closeModal={() => this.controllerTempoRetiradaModal(this.state.isRetiradaOpen)}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930  ? entrada : mobile}
                    contentLabel="Modal"
                    >
                        <ModalSelect
                        selecionar={(horario) => this.setTempoRetirada(horario)}
                        closeModal={() => this.controllerTempoRetiradaModal(this.state.isRetiradaOpen)}/>
                </Modal>
            {this.state.carregou ?
            <div className="div-pai">
                <div className="div-rota">

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/'}>
                    <span
                        className="rotas" >
                        Início
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/configuracoes'}>
                    <span
                        className="rotas" >
                        Configurações
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/configuracoes/meu-restaurante'}>
                    <span>
                        Meu restaurante
                    </span>
                </Link>

                </div>

                <div className="titulo">

                    <img alt="" className="emoji" src={Empresa} />

                    <h1>Meu restaurante</h1>

                    <h5>Configure o seu restaurante da sua maneira.</h5>

                </div>                

                <Atencao open={this.state.alerta}>
                    <div className="box" 
                        //onClick={() => this.setState({alerta: !this.state.alerta})}
                    >
                        <div className="left">
                            <img alt="" src={Alerta} className="alerta"/>
                            <h5>Atenção</h5>
                        </div>
                        {/* <FiChevronDown color={'#000000'} size={24} className="chevron"/> */}
                    </div>

                    {/* { this.state.alerta ?  */}
                    <div className="textos">
                        <h5>É expressamente proibida a divulgação de números <p>de telefone dentro do aplicativo.</p></h5>
                    </div>
                    
                    <div className="textos-mobile">
                        <h5>É expressamente proibida a divulgação de números de telefone dentro do aplicativo.</h5>
                    </div>
                    {/* : null} */}
                </Atencao>

                <hr className="linha"/>

                <div className="infos">
                    <div className="left">
                    <h2>Informações básicas</h2>
                    <h5>Personalize a aparência do seu restaurante.</h5>

                    <div className={
                        // this.state.nomeClass
                        'div-input-disabled'
                    }>
                            <input
                                value={this.state.nome}
                                onFocus={() => {
                                    this.setState({
                                        nomeClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        nomeClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="nome"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                disabled
                                required
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Nome do seu restaurante</span>
                            </label>
                    </div>
                    <h4>Tipo de cozinha do restaurante</h4>
                    <div className="cozinhas">

                        {
                            this.state.cozinhas.map(item => (
                                <div className="cozinha" key={item.id}>
                                    <span>{item.cozinha.nome}</span>
                                </div>
                            ))
                        }       
                    </div>

                    <div className="dropzones">
                        <h4>Imagem de capa</h4>

                            <Dropzone accept="image/jpeg, image/png, image/pjpeg" multiple={false} onDropAccepted={
                                (file) => this.state.superUser ? 
                                this.state.permission === 2 ? this.handleUploadCapa(file) : null 
                                : this.handleUploadCapa(file)
                            }>
                                {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                    <DropContainer
                                        {...getRootProps()}
                                        haveImage={!!this.state.uploadedCapa.length}
                                        isDragActive={isDragActive}
                                        isDragReject={isDragReject}
                                    >
                                        <input {...getInputProps()}/>
                                        <img src={ImageIcon} alt="" className="icon-image"/>
                                        {this.renderDragMessage(isDragActive, isDragReject, this.state.uploadedCapa, 0)}
                                        {!!this.state.uploadedCapa.length && (
                                            <div style={{width: 28, height: 28, marginTop: 3}}>
                                            {!this.state.uploadedCapa[0].uploaded && !this.state.uploadedCapa[0].error && !isDragActive && (
                                                <CircularProgressbar
                                                styles={{
                                                    root: { width: 24 },
                                                    path: { stroke: '#333333' }
                                                }}
                                                strokeWidth={10}
                                                value={this.state.uploadedCapa[0].progress}
                                                />
                                            )}
                                            { this.state.uploadedCapa[0].uploaded && !this.state.uploadedCapa[0].error && !isDragActive && <MdCheckCircle size={28} color="#4e9721" /> }
                                            { this.state.uploadedCapa[0].error && !this.state.uploadedCapa[0].uploaded && !isDragActive && <MdError size={28} color="#c32027" /> }
                                        </div>)}
                                    </DropContainer>
                                )}
                            </Dropzone>

                            <h4>Logotipo</h4>

                            <Dropzone accept="image/jpeg, image/png, image/pjpeg" multiple={false} onDropAccepted={
                                (file) => this.state.superUser ? 
                                this.state.permission === 2 ? this.handleUploadLogo(file) : null 
                                : this.handleUploadLogo(file)
                            }>
                                {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                    <DropContainer
                                        {...getRootProps()}
                                        haveImage={!!this.state.uploadedLogo.length}
                                        isDragActive={isDragActive}
                                        isDragReject={isDragReject}
                                    >
                                        <input {...getInputProps()}/>
                                        <img src={ImageIcon} alt="" className="icon-image"/>
                                        {this.renderDragMessage(isDragActive, isDragReject, this.state.uploadedLogo, 1)}
                                        {!!this.state.uploadedLogo.length && (
                                            <div style={{width: 28, height: 28, marginTop: 3}}>
                                            {!this.state.uploadedLogo[0].uploaded && !this.state.uploadedLogo[0].error && !isDragActive && (
                                                <CircularProgressbar
                                                styles={{
                                                    root: { width: 24 },
                                                    path: { stroke: '#333333' }
                                                }}
                                                strokeWidth={10}
                                                value={this.state.uploadedLogo[0].progress}
                                                />
                                            )}
                                            { this.state.uploadedLogo[0].uploaded && !isDragActive && <MdCheckCircle size={28} color="#4e9721" /> }
                                            { this.state.uploadedLogo[0].error && !isDragActive && <MdError size={28} color="#c32027" /> }
                                        </div>)}
                                    </DropContainer>
                                )}
                            </Dropzone>
                    </div>

                    <div className="frame">
                        <div className="celular">
                            <img
                                className="tab"
                                src={Bar} alt=""/>
                            <div className="top-tab">
                                <div className="div-nome">
                                    <IoArrowBack color={'#fff'} size={18} className="icon"/>
                                        <span className="nome-celular">
                                            {this.state.nome}
                                        </span>
                                </div>
                            <IoSearch color={'#fff'} size={18} className="icon"/>
                            </div>
                            <Dropzone accept="image/jpeg, image/png, image/pjpeg" multiple={false} onDropAccepted={
                                (file) => this.state.superUser ? 
                                this.state.permission === 2 ? this.handleUploadCapa(file) : null 
                                : this.handleUploadCapa(file)
                            }>
                                {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                    <div className="capa"
                                        {...getRootProps()}
                                        haveImage={!!this.state.uploadedCapa.length}
                                        isDragActive={isDragActive}
                                        isDragReject={isDragReject}
                                    >
                                        <input {...getInputProps()}/>
                                        <img
                                        src={!!this.state.uploadedCapa.length ? this.state.uploadedCapa[0].preview 
                                        : CapaVazia} alt=""/>
                                            {!!this.state.uploadedCapa.length && (
                                            <div className="process-capa">
                                                <div style={{width: 28, height: 28}}>
                                                {!this.state.uploadedCapa[0].uploaded && !this.state.uploadedCapa[0].error && !isDragActive && (
                                                    <CircularProgressbar
                                                    styles={{
                                                        root: { width: 24 },
                                                        path: { stroke: '#333333' }
                                                    }}
                                                    strokeWidth={10}
                                                    value={this.state.uploadedCapa[0].progress}
                                                    />
                                                )}
                                                { this.state.uploadedCapa[0].uploaded && !this.state.uploadedCapa[0].error && !isDragActive && <MdCheckCircle size={28} color="#4e9721" /> }
                                                { this.state.uploadedCapa[0].error && !this.state.uploadedCapa[0].uploaded && !isDragActive && <MdError size={28} color="#c32027" /> }
                                                </div>
                                            </div>)}
                                    </div>
                                )}
                            </Dropzone>
                            <Dropzone accept="image/jpeg, image/png, image/pjpeg" multiple={false} onDropAccepted={
                                (file) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleUploadLogo(file) : null 
                                    : this.handleUploadLogo(file)
                                }>
                                {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                    <div className="logo"
                                        {...getRootProps()}
                                        haveImage={!!this.state.uploadedLogo.length}
                                        isDragActive={isDragActive}
                                        isDragReject={isDragReject}
                                    >
                                        <input {...getInputProps()}/>
                                        <img
                                            src={!!this.state.uploadedLogo.length ? this.state.uploadedLogo[0].preview 
                                            : LogoVazia} alt=""/>
                                                {!!this.state.uploadedLogo.length && (
                                                    <div className="process-logo">
                                                    <div style={{width: 28, height: 28}}>
                                                    {!this.state.uploadedLogo[0].uploaded && !this.state.uploadedLogo[0].error && !isDragActive && (
                                                    <CircularProgressbar
                                                    styles={{
                                                        root: { width: 24 },
                                                        path: { stroke: '#333333' }
                                                    }}
                                                    strokeWidth={10}
                                                    value={this.state.uploadedLogo[0].progress}
                                                    />
                                                )}
                                                { this.state.uploadedLogo[0].uploaded && !isDragActive && <MdCheckCircle size={28} color="#4e9721" /> }
                                                { this.state.uploadedLogo[0].error && !isDragActive && <MdError size={28} color="#c32027" /> }
                                                    </div>
                                                </div>)}
                                    </div>
                                )}
                            </Dropzone>

                            <span className="descricao">
                                {this.state.descricao === '' ? 'Digite a sua descrição' : this.state.descricao}
                            </span>

                            <div className="tabs">
                                <img
                                    src={Tabs} alt=""/>
                            </div>
                            
                        </div>
                    </div>

                    <div className="ingredientes">
                        <div className="title">
                        <h4>Descrição do restaurante</h4>
                        <span>
                            <span style={ !!this.state.descricao.length ? { fontWeight: 550 } : null}>
                            {this.state.descricao.length}
                            </span>/560</span>
                        </div>

                        <div className={this.state.descClass}>
                            <textarea
                                maxLength={560}
                                value={this.state.descricao}
                                onFocus={() => {
                                    this.setState({
                                        descClass: 'div-input-focado-box'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        descClass: 'div-input-box'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="descricao"
                                type="text"
                                required
                                // placeholder="Digite o seu usuário"
                                />
                            
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Digite uma descrição</span>
                            </label>
                        </div>
                    </div>
                                                    
                    {/* <h4>Descrição do restaurante</h4> */}
                    {/* <div className={this.state.descClass}>
                            <textarea
                                maxLength={560}
                                value={this.state.descricao}
                                onFocus={() => {
                                    this.setState({
                                        descClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        descClass: 'div-input-descricao'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="descricao"
                                type="text"
                                required
                                // placeholder="Digite o seu usuário"
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Digite uma descrição</span>
                            </label>
                    </div> */}
                    {this.state.superUser ? (
                        this.state.permission === 2 ? (
                            <div className="botao">
                            <button
                                className="salvar" 
                                onClick={() => {this.updateInfos()}}>Salvar alterações</button>
                            </div>
                        ) : null
                    ) : (
                        <div className="botao">
                        <button
                            className="salvar" 
                            onClick={() => {this.updateInfos()}}>Salvar alterações</button>
                        </div>
                    )}
                </div>

                
                <div className="right">
                    <div className="branco"/>
                        <div className="marvel-device iphone8plus black">
                            <div className="top-bar"></div>
                            <div className="sleep"></div>
                            <div className="volume"></div>
                            <div className="camera"></div>
                            <div className="sensor"></div>
                            <div className="speaker"></div>
                            <div className="screen">
                                {content}
                            </div>
                            <div className="home"></div>
                            <div className="bottom-bar"></div>
                        </div>
                </div>
                    </div>
                    
                <hr className="linha"/>

                <div className="endereco">
                    <h2>Endereço</h2>
                    <h5>Adicione o endereço do seu restaurante.</h5>

                    <div className={this.state.cepError ? 'div-input-error' : this.state.cepClass}>
                            <input
                                value={this.state.cep ? this.state.cep : 'Cep não encontrado'}
                                onFocus={() => {
                                    this.setState({
                                        cepClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        cepClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="cep"
                                maxLength={9}
                                type="text"
                                required
                                // placeholder="Digite o seu usuário"
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Digite o seu CEP</span>
                            </label>
                            {
                                this.state.cepLoading ?
                                <Spinner
                                className='spinner'
                                color="#c42027" size={16} speed={1} animating={true} />
                                : null
                            }
                    </div>

                    {
                        this.state.cepClass === 'div-input-error' || this.state.cepError ?
                        <div className="div-invalido" style={{marginBottom: 32}}>
                            <span
                                className='texto-invalido'
                                >CEP inválido</span>
                        </div>  
                        : null
                    }

                    <div className="div-invalido" style={{marginTop: -24, marginBottom: 32}}>
                        <span className="find-cep">
                            Não sabe o seu CEP? <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/default.cfm">Pesquise aqui</a>
                        </span>
                    </div>

                    <div className={
                        // this.state.enderecoClass
                        'div-input-disabled'
                    }
                    >
                            <input
                                value={this.state.cep.length === 9 ? this.state.endereco : ''}
                                onFocus={() => {
                                    this.setState({
                                        enderecoClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        enderecoClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="endereco"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                // disabled={this.state.cep.length >= 9 && this.state.cepClass !== 'div-input-error' && !this.state.cepError ? false : true}
                                disabled
                                required
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Endereço</span>
                            </label>
                    </div>

                    <div className={this.state.numeroClass}>
                            <input
                                value={this.state.cep.length === 9 && this.state.endereco !== '' ? this.state.numero : ''}
                                onFocus={() => {
                                    this.setState({
                                        numeroClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        numeroClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="numero"
                                type="text"
                                required
                                // placeholder="Digite o seu usuário"
                                disabled={this.state.cep.length >= 9 && this.state.cepClass !== 'div-input-error' && this.state.endereco !== '' ? false : true}
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Número</span>
                            </label>
                    </div>

                    <div className={
                        //this.state.bairroClass
                        'div-input-disabled'
                        }>
                            <input
                                value={this.state.cep.length === 9 && this.state.endereco !== '' ? this.state.bairro : ''}
                                onFocus={() => {
                                    this.setState({
                                        bairroClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        bairroClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="bairro"
                                type="text"
                                required
                                // placeholder="Digite o seu usuário"
                                //disabled={this.state.cep.length >= 9 && this.state.cepClass !== 'div-input-error' && this.state.endereco !== '' ? false : true}
                                disabled
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Bairro</span>
                            </label>
                    </div>

                    <div className={
                        // this.state.cidadeClass
                        'div-input-disabled'
                        }>
                            <input
                                value={this.state.cidade}
                                onFocus={() => {
                                    this.setState({
                                        cidadeClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        cidadeClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="cidade"
                                type="text"
                                required
                                // placeholder="Digite o seu usuário"
                                disabled
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Cidade</span>
                            </label>

                                <button
                                    className="botao-olho"
                                    onClick={() => {}}
                                    >
                                    <FiChevronDown size={22} color="#1c0506" className="i" />
                                </button>
                    </div>

                    <h5>Caso você tenha algum complemento no seu endereço, <p>preencha o campo abaixo:</p></h5>

                    <div className={this.state.complementoClass}>
                            <input
                                value={this.state.complemento}
                                onFocus={() => {
                                    this.setState({
                                        complementoClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        complementoClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                                name="complemento"
                                type="text"
                                required
                                // placeholder="Digite o seu usuário"
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Complemento</span>
                            </label>
                    </div>
                    {this.state.superUser ? (
                        this.state.permission === 2 ? (
                            <div className="botao">
                            <button
                                className="salvar" 
                                onClick={() => {this.putEndereco()}}>Salvar alterações</button>
                            </div>
                        ) : null
                    ) : (
                        <div className="botao">
                        <button
                            className="salvar" 
                            onClick={() => {this.putEndereco()}}>Salvar alterações</button>
                        </div>
                    )}
                </div>

                <hr className="linha"/>

                <div className="minimo">
                    <h2>Valor mínimo de pedido</h2>
                    <h5>Para que o cliente possa finalizar seu pedido, o total de sua <p>compra deve ser no mínimo esse valor.</p></h5>
                    
                    <div className={this.state.valorClass}>
                            <CurrencyInput
                                inputType="text"
                                maxLength="9"
                                name="valor"
                                prefix="R$ "
                                onFocus={() => {
                                    this.setState({
                                        valorClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        valorClass: 'div-input'
                                    })
                                }}
                                required
                                decimalSeparator=","
                                value={this.state.valor}
                                onChangeEvent={
                                    (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                }
                            />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Digite um valor mínimo</span>
                            </label>
                    </div>
                    
                    {this.state.superUser ? (
                        this.state.permission === 2 ? (
                            <div className="botao">
                            <button
                                className="salvar" 
                                onClick={() => {this.putMinimo()}}>Salvar alterações</button>
                            </div>
                        ) : null
                    ) : (
                        <div className="botao">
                        <button
                            className="salvar" 
                            onClick={() => {this.putMinimo()}}>Salvar alterações</button>
                        </div>
                    )}
                </div>

                <hr className="linha"/>

                <div className="tempo">
                    <h2>Tempo de entrega</h2>
                    <h5>Este valor representa a média de tempo necessária para os pedidos <p>saírem para entrega ao cliente.</p></h5>

                    <div className={this.state.tempoClass} onClick={
                        () => this.state.superUser ? 
                                this.state.permission === 2 ? this.controllerModal(this.state.isOpen) : null 
                                : this.controllerModal(this.state.isOpen)
                        }>
                            <input
                                value={this.state.tempo}
                                name="valor"
                                type="text"
                                required
                                style={{
                                    caretColor: 'transparent'
                                }}
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Escolha um tempo médio</span>
                            </label>
                                <button
                                    className="botao-olho"
                                    >
                                    <FiChevronDown size={22} color="#1c0506" className="i" />
                                </button>
                    </div>
                    {this.state.superUser ? (
                        this.state.permission === 2 ? (
                            <div className="botao">
                            <button
                                className="salvar" 
                                onClick={() => {this.putEntrega()}}>Salvar alterações</button>
                            </div>
                        ) : null
                    ) : (
                        <div className="botao">
                        <button
                            className="salvar" 
                            onClick={() => {this.putEntrega()}}>Salvar alterações</button>
                        </div>
                    )}
                </div>

                <hr className="linha"/>

                <div className="retirada">
                    <h2>Retirada no local</h2>
                    <h5>Ao deixar esta opção ativada, clientes poderão optar por realizar <p>o pedido e retirá-los pessoalmente no estabelecimento.</p></h5>
                    
                    <label className="aberto-fechado">
                        <Switch
                            onChange={
                                () => this.state.superUser ? 
                                this.state.permission === 2 ? this.setState({ retirada: !this.state.retirada }) : null 
                                : this.setState({ retirada: !this.state.retirada })
                            }
                            defaultChecked={this.state.retirada}
                            checked={this.state.retirada}
                        />
                        <h4>{this.state.retirada ? 'Ativado' : 'Desativado'}</h4>
                    </label>

                    <h6>Ao deixar esta opção ativada, clientes poderão optar por fazer <p>o pedido e retirá-los pessoalmente no estabelecimento.</p></h6>

                    {this.state.superUser ? (
                        this.state.permission === 2 ? (
                            <div className="botao">
                            <button
                                className="salvar" 
                                onClick={() => {this.putRetirada()}}>Salvar alterações</button>
                            </div>
                        ) : null
                    ) : (
                        <div className="botao">
                        <button
                            className="salvar" 
                            onClick={() => {this.putRetirada()}}>Salvar alterações</button>
                        </div>
                    )}
                </div>
                
            {this.state.retirada ? 
            
                <div className="tempo">
                    <h2>Tempo de retirada</h2>
                    <h5>Este valor representa a média de tempo necessária para os pedidos <p>estarem disponíveis para o cliente retirar.</p></h5>

                    <div className={this.state.tempoRetiradaClass} onClick={
                        () => this.state.superUser ? 
                                this.state.permission === 2 ? this.controllerTempoRetiradaModal(this.state.isRetiradaOpen) : null 
                                : this.controllerTempoRetiradaModal(this.state.isRetiradaOpen)
                        }>
                            <input
                                value={this.state.tempo_retirada}
                                name="tempoRetirada"
                                type="text"
                                required
                                style={{
                                    caretColor: 'transparent'
                                }}
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Escolha um tempo médio</span>
                            </label>
                                <button
                                    className="botao-olho"
                                    >
                                    <FiChevronDown size={22} color="#1c0506" className="i" />
                                </button>
                    </div>
                    {this.state.superUser ? (
                        this.state.permission === 2 ? (
                            <div className="botao">
                            <button
                                className="salvar" 
                                onClick={() => {this.putRetirada()}}>Salvar alterações</button>
                            </div>
                        ) : null
                    ) : (
                        <div className="botao">
                        <button
                            className="salvar" 
                            onClick={() => {this.putRetirada()}}>Salvar alterações</button>
                        </div>
                    )}
                </div> : null}
                
            </div>
            :null}
            </Container>
            )
        )
    }
}
